// Procedure Questionnaire Template
// This template defines the structure of the procedure questionnaire form
// Version 1.1.0

const procedureQuestionnaireTemplateV1 = {
  resourceType: "ProcedureQuestionnaire",
  id: "procedure-questionnaire",
  title: "Procedure Documentation",
  status: "inactive",
  version: "1.0.0",
  item: [
    {
      linkId: "preOperative",
      text: "Pre-Operative Assessment-To be filled by the anesthetist",
      type: "group",
      item: [
        {
          linkId: "preOpVitals",
          text: "Pre-Operative Vitals",
          type: "group",
          item: [
            { linkId: "preOpBP", text: "Blood Pressure", type: "string", placeholder: "e.g., 120/80" },
            { linkId: "preOpHR", text: "Heart Rate", type: "string", placeholder: "e.g., 72 bpm" },
            { linkId: "preOpTemp", text: "Temperature", type: "string", placeholder: "e.g., 36.5°C" },
            { linkId: "preOpRespRate", text: "Respiratory Rate", type: "string", placeholder: "e.g., 16 breaths/min" }
          ]
        },
        {
          linkId: "preOpSystemExam",
          text: "System Examinations",
          type: "group",
          item: [
            { linkId: "cardiovascular", text: "Cardiovascular System", type: "text" },
            { linkId: "chest", text: "Chest", type: "text" },
            { linkId: "gastrointestinal", text: "Gastrointestinal System", type: "text" },
            { linkId: "neurological", text: "Neurological System", type: "text" },
            { linkId: "musculoskeletal", text: "Musculoskeletal System", type: "text" }
          ]
        },
        {
          linkId: "preOpInvestigations",
          text: "Pre-Operative Investigations",
          type: "group",
          item: [
            { linkId: "labResults", text: "Laboratory Results", type: "text" },
            { linkId: "imagingResults", text: "Imaging Results", type: "text" },
            { linkId: "ecgResults", text: "ECG Results", type: "text" },
            { linkId: "otherInvestigations", text: "Other Investigations", type: "text" }
          ]
        },
        {
          linkId: "preOpAssessment",
          text: "Pre-Operative Assessment",
          type: "group",
          item: [
            { linkId: "asaClass", text: "ASA Classification", type: "choice", options: ["ASA I", "ASA II", "ASA III", "ASA IV", "ASA V"] },
            { linkId: "riskAssessment", text: "Risk Assessment", type: "text" },
            { linkId: "anesthesiaType", text: "Type of Anesthesia", type: "choice", options: ["General", "Regional", "Local", "Sedation"] },
            { linkId: "consentObtained", text: "Informed Consent Obtained", type: "boolean" }
          ]
        }
      ]
    },
    {
      linkId: "intraOperative - to be filled by the surgeon",
      text: "Intra-Operative Report",
      type: "group",
      item: [
        {
          linkId: "procedureDetails",
          text: "Procedure Details",
          type: "group",
          item: [
            { linkId: "startTime", text: "Start Time", type: "datetime-local" },
            { linkId: "endTime", text: "End Time", type: "datetime-local" },
            { linkId: "surgeonReport", text: "Surgeon's Report", type: "text" }
          ]
        }
      ]
    },
    {
      linkId: "intraOpConsumables",
      text: "Intra-Operative Consumables",
      type: "group",
      item: [
        {
          linkId: "medications",
          text: "Medications Used",
          type: "group",
          item: [
            { linkId: "anesthetics", text: "Anesthetic Agents", type: "text" },
            { linkId: "antibiotics", text: "Prophylactic Antibiotics", type: "text" },
            { linkId: "otherMedications", text: "Other Medications", type: "text" }
          ]
        },
        {
          linkId: "supplies",
          text: "Medical Supplies",
          type: "group",
          item: [
            { linkId: "sutures", text: "Sutures", type: "text" },
            { linkId: "dressings", text: "Dressings", type: "text" },
            { linkId: "instruments", text: "Special Instruments", type: "text" },
            { linkId: "disposables", text: "Disposable Items", type: "text" }
          ]
        }
      ]
    },
    {
      linkId: "postOperative",
      text: "Post-Operative Plan",
      type: "group",
      item: [
        {
          linkId: "immediatePostOp",
          text: "Immediate Post-Operative Care",
          type: "group",
          item: [
            { linkId: "postOpTreatmentPlan", text: "Treatment Plan", type: "text" }
          ]
        }
      ]
    },
    {
      linkId: "signatures",
      text: "Signatures and Verification",
      type: "group",
      item: [
        { linkId: "primarySurgeon", text: "Primary Surgeon Signature", type: "signature", required: true },
        { linkId: "primarySurgeonName", text: "Primary Surgeon Name", type: "string", required: true },
        { linkId: "assistantSurgeon", text: "Assistant Surgeon Signature", type: "signature" },
        { linkId: "assistantSurgeonName", text: "Assistant Surgeon Name", type: "string" },
        { linkId: "anesthetist", text: "Anesthetist Signature", type: "signature" },
        { linkId: "anesthetistName", text: "Anesthetist Name", type: "string" },
        { linkId: "scrubNurse", text: "Scrub Nurse Signature", type: "signature" },
        { linkId: "scrubNurseName", text: "Scrub Nurse Name", type: "string" },
        { linkId: "circulatingNurse", text: "Circulating Nurse Signature", type: "signature" },
        { linkId: "circulatingNurseName", text: "Circulating Nurse Name", type: "string" },
        { linkId: "procedureDate", text: "Procedure Date", type: "date", required: true },
        { linkId: "completionTime", text: "Form Completion Time", type: "datetime-local", required: true }
      ]
    }
  ]
};

const procedureQuestionnaireTemplateV11 = {
  resourceType: "ProcedureQuestionnaire",
  id: "procedure-questionnaire",
  title: "Procedure Documentation",
  status: "active",
  version: "1.1.0",
  item: [
   
    {
      linkId: "preOperative",
      text: "Pre-Operative Assessment (To be filled by Anesthetist)",
      type: "group",
      item: [
        {
          linkId: "preOpVitals",
          text: "Pre-Operative Vitals (Required)",
          type: "group",
          required: true,
          item: [
            { linkId: "preOpBP", text: "Blood Pressure (mmHg)", type: "string", required: true, placeholder: "Systolic/Diastolic (e.g., 120/80)" },
            { linkId: "preOpHR", text: "Heart Rate (beats/min)", type: "string", required: true, placeholder: "60-100 normal range" },
            { linkId: "preOpTemp", text: "Temperature (°C)", type: "string", required: true, placeholder: "36.0-37.5 normal range" },
            { linkId: "preOpRespRate", text: "Respiratory Rate (breaths/min)", type: "string", required: false, placeholder: "12-20 normal range" },
            { linkId: "preOpO2Sat", text: "Oxygen Saturation (%)", type: "string", placeholder: "95-100% normal range" },
            { linkId: "preOpWeight", text: "Weight (kg)", type: "string", placeholder: "Required for medication dosing" }
          ]
        },
        {
          linkId: "preOpSystemExam",
          text: "System Examinations",
          type: "group",
          item: [
            { linkId: "cardiovascular", text: "Cardiovascular System", type: "text", placeholder: "Heart sounds, murmurs, rhythm" },
            { linkId: "chest", text: "Chest/Respiratory", type: "text", placeholder: "Breath sounds, chest expansion" },
            { linkId: "gastrointestinal", text: "Gastrointestinal System", type: "text", placeholder: "Abdomen examination" },
            { linkId: "neurological", text: "Neurological System", type: "text", placeholder: "Consciousness, reflexes, motor/sensory" },
            { linkId: "musculoskeletal", text: "Musculoskeletal System", type: "text", placeholder: "Joint mobility, muscle strength" },
            { linkId: "airwayAssessment", text: "Airway Assessment", type: "text", placeholder: "Mallampati score, neck mobility" }
          ]
        },
        {
          linkId: "preOpInvestigations",
          text: "Pre-Operative Investigations",
          type: "group",
          item: [
            { linkId: "labResults", text: "Laboratory Results", type: "text", placeholder: "CBC, chemistry panel, coagulation studies" },
            { linkId: "imagingResults", text: "Imaging Results", type: "text", placeholder: "X-ray, CT, MRI findings" },
            { linkId: "ecgResults", text: "ECG Results", type: "text", placeholder: "Rhythm, rate, abnormalities" },
            { linkId: "pulmonaryFunction", text: "Pulmonary Function Tests", type: "text", placeholder: "If indicated" },
            { linkId: "otherInvestigations", text: "Other Investigations", type: "text", placeholder: "Echo, stress test, etc." }
          ]
        },
        {
          linkId: "preOpAssessment",
          text: "Pre-Operative Assessment (Required)",
          type: "group",
          required: true,
          item: [
            { linkId: "asaClass", text: "ASA Physical Status Classification", type: "choice", required: true, options: ["ASA I - Normal healthy patient", "ASA II - Mild systemic disease", "ASA III - Severe systemic disease", "ASA IV - Life-threatening disease", "ASA V - Moribund patient"] },
            { linkId: "riskAssessment", text: "Anesthetic Risk Assessment", type: "text", required: true, placeholder: "Low/Moderate/High risk and reasons" },
            { linkId: "anesthesiaType", text: "Planned Anesthesia Type", type: "choice", required: true, options: ["General Anesthesia", "Spinal Anesthesia", "Epidural Anesthesia", "Regional Block", "Local Anesthesia", "MAC/Sedation"] },
            { linkId: "specialConsiderations", text: "Special Anesthetic Considerations", type: "text", placeholder: "Allergies, difficult airway, comorbidities" },
            { linkId: "consentObtained", text: "Informed Consent Obtained", type: "boolean", required: true },
            { linkId: "consentTime", text: "Consent Obtained Time", type: "datetime-local", placeholder: "When consent was signed" }
          ]
        }
      ]
    },
    {
      linkId: "intraOperative",
      text: "Intra-Operative Report (To be filled by Surgeon)",
      type: "group",
      item: [
        {
          linkId: "procedureDetails",
          text: "Procedure Details (Required)",
          type: "group",
          required: true,
          item: [
            { linkId: "startTime", text: "Procedure Start Time", type: "datetime-local", required: true },
            { linkId: "endTime", text: "Procedure End Time", type: "datetime-local", required: true },
            { linkId: "surgicalApproach", text: "Surgical Approach", type: "choice", options: ["Open", "Laparoscopic", "Endoscopic", "Percutaneous", "Other"] },
            { linkId: "surgeonReport", text: "Detailed Operative Report", type: "text", required: true, placeholder: "Detailed description of procedure, findings, and techniques used" },
            { linkId: "complications", text: "Intra-operative Complications", type: "text", placeholder: "Any complications encountered during surgery" },
            { linkId: "estimatedBloodLoss", text: "Estimated Blood Loss (mL)", type: "string", placeholder: "Amount in milliliters" }
          ]
        },
        {
          linkId: "intraOpVitals",
          text: "Intra-operative Monitoring",
          type: "group",
          item: [
            { linkId: "anesthesiaStart", text: "Anesthesia Start Time", type: "datetime-local" },
            { linkId: "anesthesiaEnd", text: "Anesthesia End Time", type: "datetime-local" },
            { linkId: "vitalsSummary", text: "Vital Signs Summary", type: "text", placeholder: "Stable/Notable events during procedure" },
            { linkId: "fluidBalance", text: "Fluid Input/Output", type: "text", placeholder: "IV fluids, blood products, urine output" }
          ]
        }
      ]
    },
    {
      linkId: "intraOpConsumables",
      text: "Intra-Operative Consumables (For Billing)",
      type: "group",
      item: [
        {
          linkId: "medications",
          text: "Medications Used",
          type: "group",
          item: [
            { linkId: "anesthetics", text: "Anesthetic Agents", type: "text", placeholder: "Type, dose, route" },
            { linkId: "antibiotics", text: "Prophylactic Antibiotics", type: "text", placeholder: "Drug name, dose, timing" },
            { linkId: "analgesics", text: "Pain Medications", type: "text", placeholder: "Opioids, NSAIDs used" },
            { linkId: "emergencyMeds", text: "Emergency Medications", type: "text", placeholder: "Vasopressors, cardiac drugs if used" },
            { linkId: "otherMedications", text: "Other Medications", type: "text", placeholder: "Anti-emetics, muscle relaxants, etc." }
          ]
        },
        {
          linkId: "supplies",
          text: "Medical Supplies (Itemize for Billing)",
          type: "group",
          item: [
            { linkId: "sutures", text: "Sutures", type: "text", placeholder: "Type, size, quantity" },
            { linkId: "dressings", text: "Dressings and Bandages", type: "text", placeholder: "Type and quantity used" },
            { linkId: "instruments", text: "Special Instruments", type: "text", placeholder: "Single-use instruments, implants" },
            { linkId: "disposables", text: "Disposable Items", type: "text", placeholder: "Gloves, gowns, drapes, catheters" },
            { linkId: "bloodProducts", text: "Blood Products", type: "text", placeholder: "Type, units, cross-match details" }
          ]
        }
      ]
    },
    {
      linkId: "signatures",
      text: "Signatures and Verification (All Required)",
      type: "group",
      required: true,
      item: [
        { linkId: "primarySurgeon", text: "Primary Surgeon Signature", type: "signature", required: true },
        { linkId: "primarySurgeonName", text: "Primary Surgeon Name", type: "string", required: true, placeholder: "Dr. Full Name" },
        { linkId: "anesthetist", text: "Anesthetist Signature", type: "signature", required: true },
        { linkId: "anesthetistName", text: "Anesthetist Name", type: "string", required: true, placeholder: "Dr. Full Name" },
        { linkId: "procedureDate", text: "Procedure Date", type: "date", required: true },
        { linkId: "completionTime", text: "Form Completion Time", type: "datetime-local", required: true },
        { linkId: "reviewedBy", text: "Reviewed and Approved By", type: "string", placeholder: "Department Head/Senior Physician" }
      ]
    }
  ]
};

// Current version of the questionnaire template
export const CURRENT_PROCEDURE_QUESTIONNAIRE_VERSION = "1.1.0";

// Map to store different versions of templates
const procedureQuestionnaireTemplates = new Map([
  ["1.0.0", procedureQuestionnaireTemplateV1],
  ["1.1.0", procedureQuestionnaireTemplateV11]
]);

// Function to get a specific version of the questionnaire template
export const getProcedureQuestionnaireTemplate = (version) => {
  return procedureQuestionnaireTemplates.get(version) || procedureQuestionnaireTemplateV11;
};

// Function to get the latest questionnaire template
export const getLatestProcedureQuestionnaireTemplate = () => {
  return procedureQuestionnaireTemplateV11;
};

export default procedureQuestionnaireTemplateV11;
